<template>
  <div 
    class="app-modal" 
    :class="modifiedClass" 
  >
    <button 
      type="button" 
      class="app-modal__close-btn"
      @click.stop="$emit('close')"
    >
      <span class="material-symbols-outlined">
        close
      </span>
    </button>
    
    <main class="app-modal__content" ref="modalRef">
      <h1 class="app-modal__headline">{{ headline }}</h1>

      <slot />
    </main>
  </div>
</template>

<script>
  export default {
    name: 'AppModal',

    props: {
      isVisible: {
        type: Boolean,
        default: false
      },
      headline: {
        type: String,
        default: 'Modal headline'
      }
    },

    mounted() {
      document.addEventListener('click', this.onOutsideClick)
    },

    beforeDestroy() {
      document.removeEventListener('click', this.onOutsideClick)
    },

    data: () => ({
      modalRef: null
    }),

    computed: {
      modifiedClass() {
        return this.isVisible && 'app-modal--visible'
      }
    },

    methods: {
      onOutsideClick(e) {
        if ( !this.$refs.modalRef.contains(e.target) ) {
          this.$emit('close')
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.app-modal {
  $root: &;

  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  opacity: 0;
  z-index: 4;
  visibility: hidden;
  background-color: rgba(#000, .3);

  &__content {
    width: 100%;
    height: 100%;
    top: 50%;
    left: 50%;
    position: absolute;
    padding: 2rem;
    background-color: #fff;
    opacity: 0;
    visibility: hidden;
    transform: translate(-50%, -46%);
    transition: transform .25s, visibility .25s, opacity .25s ease;
  }

  &__close-btn {
    position: absolute;
    top: 1rem;
    right: 1rem;
    width: 50px;
    height: 50px;
    display: flex;
    z-index: 1000;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    
    span {
      font-weight: 100;
      font-size: 3rem;
      color: #222;
    }
  }

  &__headline {
    font-weight: light;
    color: #444;
    font-size: 2rem;
    margin-bottom: 4rem;

    &::after {
      content: "";
      width: 120px;
      height: 10px;
      display: block;
      margin-top: 1rem;
      background-color: #289ea8;
    }

  }

  &__content {
    height: 100%;
  }

  @media (min-width: 600px) {
    #{$root}__close-btn {
      background-color: rgba(#fff, .4);

      span {
        color: #fff;
        font-size: 1.8rem;
      }
    }

    #{$root}__content {
      width: 500px;
      height: auto;
      padding: 2rem;
      border-radius: 10px;
      box-shadow: 0 8px 12px rgba(#000, .1);
    }
  }

  &--visible {
    opacity: 1;
    visibility: visible;
    transition: visibility .25s, opacity .25s ease;

    #{$root}__content {
      opacity: 1;
      visibility: visible;
      transform: translate(-50%, -50%);
    }
  }
}
</style>